import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1c33622d"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=1c33622d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BenchmarkTitle: require('/app/nuxt/components/Benchmark/BenchmarkTitle.vue').default,BenchmarkTab: require('/app/nuxt/components/Benchmark/BenchmarkTab.vue').default,BenchmarkSearchAndFilter: require('/app/nuxt/components/Benchmark/BenchmarkSearchAndFilter.vue').default,WrapComponents: require('/app/nuxt/components/WrapComponents.vue').default})
